module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"whatWillBeAutomated":"What stops your automation?","suggestedOptions":"Suggested options","andThen":"or when","whatElse":"What else should stop this automation?"}}')
  delete Component.options._Ctor
}
